import React from "react";
import { trackEvent } from "@/components/analytics";
import { cn } from "@/lib/utils";

type BillingContactDetailsProps = {
  phone?: string | null;
  email?: string | null;
  location: "footer" | "contact";
  className?: string;
  linkClassName?: string;
};

function BillingContactDetails({
  phone,
  email,
  location,
  className,
  linkClassName,
}: BillingContactDetailsProps) {
  if (!phone && !email) {
    return null;
  }

  const phoneLink = phone ? (
    <a
      href={`tel:${phone}`}
      className={linkClassName}
      onClick={() => trackEvent("phone_click", { phone, location, type: "billing" })}
    >
      {phone}
    </a>
  ) : null;

  const emailLink = email ? (
    <a
      href={`mailto:${email}`}
      className={linkClassName}
      onClick={() => trackEvent("email_click", { email, location, type: "billing" })}
    >
      {email}
    </a>
  ) : null;

  return (
    <p className={cn("break-words", className)}>
      Have billing questions? Please {phoneLink && <>call {phoneLink}</>}
      {phoneLink && emailLink && " or "}
      {emailLink && <>email {emailLink}</>}.
    </p>
  );
}

export { BillingContactDetails };
export type { BillingContactDetailsProps };
